import { MouseEvent, ReactNode } from 'react';
import styled from 'styled-components';
import { GhostButton } from 'ui/button';
import { colors, spacing } from 'ui/theme';

const StyledNavButton = styled(GhostButton)`
  &&& {
    min-width: ${spacing.doubleHalf};
    min-height: ${spacing.doubleHalf};
    height: auto;
    padding: ${spacing.half};
    align-items: center;
    justify-content: center;
    column-gap: ${spacing.half};
    color: ${colors.textSecondary};
    border-radius: ${spacing.double};
    transition: color, background 100ms ease-in-out;
    border: none;

    &[data-active='true'] {
      color: ${colors.textLink};
      background-color: ${colors.backgroundInteractive};

      path {
        /* stylelint-disable value-keyword-case */
        stroke: currentColor;
      }
    }

    &:hover {
      color: ${colors.textPrimary};
      background-color: ${colors.backgroundPrimaryHover};
    }

    &::before {
      border-radius: ${spacing.double};
    }
  }
`;

type NavButtonProps = {
  children: ReactNode;
  id: string;
  isActive: boolean;
  onClick?: (e: MouseEvent) => void;
};

/**
 * Common, styled icon button used in nav menus and mobile menu hamburger
 */
export const NavButton = ({ children, id, isActive, onClick }: NavButtonProps) => {
  return (
    <StyledNavButton
      aria-label={id}
      id={id}
      key={id}
      data-active={isActive}
      data-test={`nav-button-${id}`}
      onClick={onClick}
    >
      {children}
    </StyledNavButton>
  );
};
